import { z } from "zod";
import { NamedExternalArtifactBuilderIdV1Schema } from "./artifact-registry-ids.js";
/** AR-006 — external artifact evidence without determinism claims. */
export const ExternalArtifactEvidenceRecordV1Schema = z
    .object({
    schemaId: z.literal("externalArtifact.evidence.v1"),
    builderId: NamedExternalArtifactBuilderIdV1Schema,
    strongestEvidenceKind: z.enum(["SNAPSHOT", "EXPORT", "RELEASE_TAG"]),
    evidenceRef: z.string().min(1),
    claimsDeterministicOutput: z.literal(false),
    disclaimerRefs: z.array(z.string().min(1)).min(1),
})
    .strict();
export function registerExternalArtifactEvidence(input) {
    return ExternalArtifactEvidenceRecordV1Schema.parse({
        schemaId: "externalArtifact.evidence.v1",
        builderId: input.builderId,
        strongestEvidenceKind: input.strongestEvidenceKind,
        evidenceRef: input.evidenceRef,
        claimsDeterministicOutput: false,
        disclaimerRefs: input.disclaimerRefs,
    });
}
//# sourceMappingURL=artifact-registry-external.js.map